export { default } from '../../TPAGallery/viewer/TPAGallery.controller';
